import React from "react";
import { useSelector } from "react-redux";
import { getKey, getTab, hasTabPermission } from "../../../../shared/utils/tabsUtils";
import { usePermission } from "../../../../shared/hooks/usePermission";
import { canShowScheduleMiniWidget } from "../../../../shared/utils/userDetailsUtils";
import HeaderMobile from "../../../layout/layoutMobile/headerMobile/HeaderMobile";
import CalendarMobileWidget from "../../../../shared/components/pages/calenderPage/calendarMobileWidget/CalendarMobileWidget";
import MyLearningWidget from "../../../../shared/components/pages/myLearningPage/myLearningWidget/MyLearningWidget";
import FocusCarousel from "../../../../shared/components/ui/focusCarousel/FocusCarousel";
import UsefulToolsCarouselWidget from "../../../../shared/components/widgetCarousel/usefulToolsCarouselWidget/UsefulToolsCarouselWidget";
import DiscoveryCarouselWidget from "../../../../shared/components/widgetCarousel/discoveryCarouselWidget/DiscoveryCarouselWidget";
import PlusLearningCarouselWidget from "../../../../shared/components/widgetCarousel/plusLearningCarouselWidget/PlusLearningCarouselWidget";
import BgtCarouselWidget from "../../../../shared/components/widgetCarousel/bgtCarouselWidget/BgtCarouselWidget";
import RealisticIsraelCarouselWidget from "../../../../shared/components/widgetCarousel/realisticIsraelCarouselWidget/RealisticIsraelCarouselWidget";
import SchoolImageWidget from "../../../../shared/components/widget/schoolImageWidget/SchoolImageWidget";
import FinalProjectCarouselWidget from "../../../../shared/components/widgetCarousel/finalProjectCarouselWidget/FinalProjectCarouselWidget";
import ChampionshipCarouselWidget from "../../../../shared/components/widgetCarousel/championshipCarouselWidget/ChampionshipCarouselWidget";
import ScheduleCarouselWidget from "../../../../shared/components/widgetCarousel/scheduleCarouselWidget/ScheduleCarouselWidget";
import MessagesCarouselWidget from "../../../../shared/components/widgetCarousel/messagesCarouselWidget/MessagesCarouselWidget";
import DefaultLogoWidget from "../../../../shared/components/widget/defaultLogoWidget/DefaultLogoWidget";
import classes from "./HomeMobile.module.css";

const HomeMobile = () => {

    const hasPermission = usePermission();
    const { user, isStudent, userDetails } = useSelector(state => state.auth);
    const { lang } = useSelector(state => state.translate);
    const permissionLlist = useSelector(state => state.uiData.permissionLlist);
    const schoolData = userDetails?.defaultSchool;
    const canSeeBgt = hasPermission(getTab("bgt")?.visibleTo);
    const canSeeRealisticIsrael = hasPermission(getTab("realisticIsrael")?.visibleTo) ? true : false;
    const canSeeChampionship = hasPermission(getTab("championship")?.visibleTo);
    const canSeeFinalProjects = hasTabPermission(user, userDetails, isStudent, lang, getTab("finalProjects")?.visibleTo, permissionLlist);
    const canSeeGoogleMeet = !hasPermission(getKey("googleMeet"));

    return (
        <div className={`${classes.HomeMobile} HomeMobile`}>
            <HeaderMobile />
            <CalendarMobileWidget />
            {schoolData?.imageUrl ? <SchoolImageWidget /> : <DefaultLogoWidget />}
            <MyLearningWidget width={360} />
            <FocusCarousel itemSize={100} activeScale={1.6} showDots={false} className={classes.WidgetsCarousel}>
                {canSeeBgt && <BgtCarouselWidget />}
                {canSeeRealisticIsrael && <RealisticIsraelCarouselWidget />}
                {/* {canSeeGoogleMeet && <GoogleMeetCarouselWidget />} */}
                <UsefulToolsCarouselWidget />
                {canShowScheduleMiniWidget(userDetails) && <ScheduleCarouselWidget />}
                <MessagesCarouselWidget />
                <DiscoveryCarouselWidget />
                <PlusLearningCarouselWidget />
                {canSeeChampionship && <ChampionshipCarouselWidget />}
                {canSeeFinalProjects && <FinalProjectCarouselWidget />}
            </FocusCarousel>
        </div>
    );
};

export default HomeMobile;
